var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25",
    "data-name": "Group 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.866,
    height: 40.866,
    viewBox: "0 0 40.866 40.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 40.866,
    height: 40.866,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M32.451,40.866H8.415A8.415,8.415,0,0,1,0,32.451V8.415A8.415,8.415,0,0,1,8.415,0H32.451a8.415,8.415,0,0,1,8.415,8.415V32.451a8.415,8.415,0,0,1-8.415,8.415",
    fill: "#edb425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M26.246,48.478a10.235,10.235,0,0,0,6.94-2.032,5.382,5.382,0,0,1-4.543-3.453,7.209,7.209,0,0,0,1.864-.182c-2.158-.946-3.555-2.368-3.612-4.825.68.06,1.2.5,2.013.444-1.988-1.942-2.591-4.052-1.342-6.624a14.49,14.49,0,0,0,7.455,4.756c.161.041.321.086.482.123a9.827,9.827,0,0,0,2.129.5c.8-.1,0-1.015.2-2.2a4.868,4.868,0,0,1,7.721-3.215A2.174,2.174,0,0,0,48,32c.455-.2.914-.395,1.453-.627-.124,1.062-.933,1.638-1.582,2.428a3.6,3.6,0,0,0,2.011-.259,3.373,3.373,0,0,1-1.319,1.612,1.891,1.891,0,0,0-.771,1.586C47.456,47.415,35.33,55.672,27.036,49.1c-.8-.637-.021,0-.79-.622",
    transform: "translate(-17.63 -20.689)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.27fad6a55ae86c21ef16724870851a9f.svg";
export { ForwardRef as ReactComponent };